import { gunterzBold, inter } from '@/theme/fonts';
import { Badge, Box, Divider, Group, NumberFormatter, Paper, SimpleGrid, Stack, Text } from '@mantine/core';
import classes from './GamePanel.module.css';
import { gameInfoData } from './data';
export const GameInfoPanel: React.FC = () => {
  const gameInfo = gameInfoData.find(item => item.id === '1');
  return <Paper bg="transparent">
      <Stack>
        <Group gap={10}>
          {gameInfo?.tag.map(item => <Badge key={item} classNames={{
          root: classes.badge
        }}>
              {item}
            </Badge>)}
        </Group>
        <Divider size="xs" color="var(--bg-400)" my={{
        base: 14,
        lg: 30
      }} />

        <SimpleGrid cols={3}>
          {gameInfo?.analytic.map(item => <Box key={item.name}>
              <Text fz={{
            base: 'sm',
            lg: 'lg'
          }} className={gunterzBold.className} c="var(--text-white)">
                {item.name}

                {item.des && <Text visibleFrom="sm" span fz={14} className={inter.className} tt="uppercase" fw={700} c="var(--text-dark)">
                    {item.des}
                  </Text>}
              </Text>

              {typeof item.value === 'string' ? <Text fz={{
            base: 'xs',
            sm: 'sm'
          }} c="var(--text-green)" fw={700} tt="uppercase">
                  {item.value}
                </Text> : <Text fz={{
            base: 'xs',
            sm: 'sm'
          }} c="var(--text-green)" fw={700}>
                  <NumberFormatter value={item.value} decimalScale={2} decimalSeparator="." suffix="%" />
                </Text>}
            </Box>)}
        </SimpleGrid>

        <Divider size="xs" color="var(--bg-400)" my={{
        base: 14,
        lg: 30
      }} />

        <Box>
          <Text fz={{
          base: 'sm',
          lg: 'lg'
        }} className={gunterzBold.className} c="var(--text-white)">
            <Text variant="gradient" gradient={{
            from: '#FF99F3',
            to: '#FF2980',
            deg: 175
          }} span inherit>
              {gameInfo?.gameName}:
            </Text>{' '}
            {gameInfo?.description}
          </Text>
          <Text fz="xs" c="var(--text-dark)">
            {gameInfo?.content}
          </Text>
        </Box>
      </Stack>
    </Paper>;
};